import React, { useState } from 'react';
import { Mail, Linkedin } from 'lucide-react';
import './Team.css';
import JobDetailsModal from '../components/JobDetailsModal';
import { jobDescriptions } from '../data/jobDescriptions';

const Team = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [showModal, setShowModal] = useState(false);
  
  const teamMembers = [
    {
      name: 'Aaron Gregory',
      role: 'Founder & CEO',
      photo: 'https://customer-assets.emergentagent.com/job_western-rail-hub/artifacts/8zsbr2t4_ChatGPT%20Image%20May%2024%2C%202026%2C%2009_20_28%20PM.png',
      bio: 'Visionary founder who established AG&WESTERN Rail Inc. on December 23, 2025. Leading the company with a commitment to revolutionize rail transportation.',
      email: 'Aaron.Gregory@agwesternrail.com',
      linkedin: '#'
    },
    {
      name: 'Jennifer Major',
      role: 'CHRO (Chief Human Resources Officer)',
      photo: 'https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/0660bb76915eacbd_2428475D-612F-4BEB-8638-FF6BE3CBBB6B.png',
      bio: 'As Chief Human Resources Officer at AG&WESTERN Rail Inc., Jennifer Major leads all people-focused initiatives including talent acquisition, employee development, organizational culture, and workforce strategy. She oversees compensation and benefits programs, ensures compliance with employment regulations, and champions diversity and inclusion efforts. Her leadership fosters a positive workplace environment that attracts and retains top talent across the organization.',
      email: 'JenniferMajor.CHRO@agwesternrail.com',
      linkedin: '#'
    },
    {
      name: 'N/A',
      role: 'President',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#'
    },
    {
      name: 'N/A',
      role: 'Vice President',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#'
    },
    {
      name: 'N/A',
      role: 'CTO (Chief Tech Officer)',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#'
    },
    {
      name: 'N/A',
      role: 'Chairman of Board',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#'
    },
    {
      name: 'N/A',
      role: 'CPO (Chief Product Officer)',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#'
    },
    {
      name: 'N/A',
      role: 'CDO (Chief Data Officer)',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#'
    },
    {
      name: 'N/A',
      role: 'COO (Chief Operating Officer)',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#',
      applicationUrl: 'https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/74091jhh_AGWestern_COO_Employment_Application.pdf'
    },
    {
      name: 'N/A',
      role: 'CRO (Chief Revenue Officer)',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#',
      applicationUrl: 'https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/x9bp1laf_AGWestern_CRO_Employment_Application.pdf'
    },
    {
      name: 'N/A',
      role: 'CXO (Chief Experience Officer)',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#',
      applicationUrl: 'https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/aht29bvy_AGWestern_CXO_Employment_Application.pdf'
    },
    {
      name: 'N/A',
      role: 'CIO (Chief Information Officer)',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#'
    },
    {
      name: 'N/A',
      role: 'CLO (Chief Legal Officer)',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#',
      applicationUrl: 'https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/9dhjwtsi_AGWestern_CLO_Employment_Application.pdf'
    },
    {
      name: 'N/A',
      role: 'Chief Secretary',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#'
    },
    {
      name: 'N/A',
      role: 'VP of Gov. Affairs',
      photo: null,
      bio: 'Position currently open.',
      email: 'info@agwesternrail.com',
      linkedin: '#',
      applicationUrl: 'https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/il48b0i8_AGWestern_VP_Government_Affairs_Employment_Application.pdf'
    }
  ];

  return (
    <div className="team">
      {/* Hero Section */}
      <section className="team-hero section-dark">
        <div className="container">
          <div className="team-hero-content">
            <h1>Our Leadership Team</h1>
            <p className="team-subtitle">
              Meet the dedicated professionals driving AG&WESTERN Rail Inc. forward
            </p>
          </div>
        </div>
      </section>

      {/* Team Grid */}
      <section className="section">
        <div className="container">
          <div className="team-grid">
            {teamMembers.map((member) => (
              <div key={member.email} className="team-card">
                <div className="team-photo">
                  {member.photo ? (
                    <img 
                      src={member.photo} 
                      alt={`${member.name} - ${member.role} at AG&WESTERN Rail Inc.`}
                      className="team-photo-image"
                      loading="lazy"
                    />
                  ) : (
                    <div className="team-photo-placeholder">
                      <span className="placeholder-text">N/A</span>
                    </div>
                  )}
                </div>
                <div className="team-info">
                  <h3>{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                  <p className="team-bio">{member.bio}</p>
                  <div className="team-contact">
                    <a href={`mailto:${member.email}`} aria-label="Email">
                      <Mail size={18} />
                    </a>
                    <a href={member.linkedin} aria-label="LinkedIn">
                      <Linkedin size={18} />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section section-gray">
        <div className="container">
          <div className="team-cta">
            <h2>Join Our Team</h2>
            <p>
              We're building a world-class team at AG&WESTERN Rail Inc. 
              Check out our current open positions and become part of our journey.
            </p>
            
            <div className="open-positions-list">
              <h3>Current Open Positions:</h3>
              <div className="positions-grid">
                {teamMembers
                  .filter(member => member.name === 'N/A')
                  .map((member) => (
                    <div 
                      key={member.role} 
                      className="position-link"
                      onClick={(e) => {
                        if (member.applicationUrl && jobDescriptions[member.role]) {
                          e.preventDefault();
                          setSelectedJob({
                            ...jobDescriptions[member.role],
                            applicationUrl: member.applicationUrl
                          });
                          setShowModal(true);
                        } else if (!member.applicationUrl) {
                          alert(`Job posting for ${member.role} will be available soon!`);
                        }
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <span className="position-title">{member.role}</span>
                      <span className="position-status">
                        {member.applicationUrl ? 'Apply Now →' : 'View Details →'}
                      </span>
                    </div>
                  ))}
              </div>
            </div>

            <div style={{
              backgroundColor: '#f8f9fa',
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              padding: '1.5rem',
              marginTop: '2rem',
              marginBottom: '2rem'
            }}>
              <p style={{
                fontSize: '0.95rem',
                lineHeight: '1.6',
                color: '#333',
                margin: 0
              }}>
                <strong>📄 Application Instructions:</strong> Click "Apply Now" to download the position's employment application. 
                Fill out the form completely and email your completed application to{' '}
                <a href="mailto:careers@agwesternrail.com" style={{color: '#000', fontWeight: '600'}}>
                  careers@agwesternrail.com
                </a>
              </p>
            </div>

            <p className="contact-hr">
              Interested in a position? Contact us at{' '}
              <a href="mailto:careers@agwesternrail.com">careers@agwesternrail.com</a>
            </p>
          </div>
        </div>
      </section>

      <JobDetailsModal 
        job={selectedJob}
        onClose={() => {
          setShowModal(false);
          setSelectedJob(null);
        }}
        onContinue={() => {
          if (selectedJob?.applicationUrl) {
            window.open(selectedJob.applicationUrl, '_blank');
          }
        }}
      />
    </div>
  );
};

export default Team;